<template>
  <div class="mt-6">
    <v-card class="spacing-bottom--16">
      <div class="d-flex">
        <div class="d-flex flex-column">
          <v-card-title class="mb-0">{{ $t("settings.application_data.environment") }}</v-card-title>
        </div>
      </div>
      <ul class="version-details mt-4">
        <li>
          {{ $t("settings.application_data.environment") }}:
          <span class="version-details__value">{{ environment }}</span>
        </li>
      </ul>
    </v-card>
    <v-card class="spacing-bottom--16">
      <v-skeleton-loader
        v-if="versionsLoading"
        class="skeleton-loader"
        type="heading, list-item-three-line"></v-skeleton-loader>
      <template v-else>
        <div class="d-flex">
          <div class="d-flex flex-column">
            <v-card-title class="mb-0">{{ $t("settings.application_data.versions") }}</v-card-title>
          </div>
        </div>
        <ul class="version-details mt-4">
          <li v-if="versions.dashboard">
            {{ $t("settings.application_data.dashboard") }}:
            <span class="version-details__value">{{ versions.dashboard }}</span>
            <v-chip v-if="dates.dashboard" class="ml-2" color="success-120" text-color="success" small>{{
              dates.dashboard
            }}</v-chip>
          </li>
          <li v-if="versions.api">
            {{ $t("settings.application_data.api") }}:
            <span class="version-details__value">{{ versions.api }}</span>
            <v-chip v-if="dates.api" class="ml-2" color="success-120" text-color="success" small>{{
              dates.api
            }}</v-chip>
          </li>
          <li v-if="versions.vuetify_admin">
            {{ $t("settings.application_data.vuetify_admin") }}:
            <span class="version-details__value"> {{ versions.vuetify_admin }} </span>
          </li>
        </ul>
      </template>
    </v-card>
  </div>
</template>

<script>
  import { format } from "date-fns";
  import packageData from "../../../../package.json";
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    name: "ApplicationData",
    data() {
      return {
        versionsLoading: false,
        environment: process.env.VUE_APP_DISPLAY_ENV,
        versions: {
          dashboard: process.env.VUE_APP_VERSION,
          vuetify_admin: packageData.dependencies["@inulti/vuetify-admin"]?.replace(/[^0-9.]/g, ""),
          api: "",
        },
        dates: {
          dashboard: this.formatTimestamp(process.env.VUE_APP_BUILD_TIMESTAMP),
          api: "",
        },
      };
    },
    async beforeMount() {
      try {
        this.versionsLoading = true;
        const { headers } = await this.$admin.dataProvider.customHttpCall("GET", `users/current`);
        this.versions.api = headers?.["api-version"];
        this.dates.api = this.formatTimestamp(headers?.["api-deployed-at"]);
      } catch (e) {
        this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
      } finally {
        this.versionsLoading = false;
      }
    },
    methods: {
      formatTimestamp(timestamp) {
        if (!timestamp || isNaN(parseInt(timestamp))) return "";

        return format(new Date(parseInt(timestamp) * 1000), "yyyy-MM-dd HH:mm:ss");
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .version {
    &-details {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        @include text-body-1();
        color: get-color("body");
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        gap: 4px;
      }
      &__value {
        color: get-color("subtitle");
      }
      &__name {
        @include heading-4();
        color: get-color("headline");
        margin-right: 8px;
      }
    }
  }
</style>
